import React, { useRef, useEffect } from "react";
import Heading from "../../components/common/Typography/Heading";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const HireWithConf = () => {
  const imageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!imageRef.current || !containerRef.current) return;
    
    gsap.set(imageRef.current, { filter: "grayscale(100%)" });
    gsap.to(imageRef.current, {
      filter: "grayscale(0%)",
      duration: 1,
      ease: "power2.out",
              scrollTrigger: {
          trigger: containerRef.current,
          start: "center center",
          toggleActions: "play none none reverse"
        },
    });
  }, []);

  return (
    <>
      <div ref={containerRef} className="mx-[5%] xl:mx-auto xl:w-[1100px] 2xl:w-[1264px] mt-10 sm:mt-40">
        <Heading variant={"h2"} className={"text-offblack"}>
          Hire with confidence
        </Heading>
        <div className="h-[500px] sm:h-auto 2xl:h-[700px] sm:aspect-[1264/700] mt-7 sm:mt-10 relative">
          <img
            ref={imageRef}
            src={require("../../assets/img/about-us.jpg")}
            className="w-full h-full rounded-xl object-cover"
            alt=""
          />
        </div>
      </div>
    </>
  );
};

export default HireWithConf;

